import { render, staticRenderFns } from "./sbDetailsParameter.vue?vue&type=template&id=10a5a1b4&scoped=true"
import script from "./sbDetailsParameter.vue?vue&type=script&lang=ts"
export * from "./sbDetailsParameter.vue?vue&type=script&lang=ts"
import style0 from "./sbDetailsParameter.vue?vue&type=style&index=0&id=10a5a1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a5a1b4",
  null
  
)

export default component.exports